import templateStr from 'text!./mobileCoveragesSummary.html';

export default {
    template: templateStr,
    bindings: {
        offering: '<',
        branchCode: '<'
    },
    controller: function controller() {
        var $ctrl = this;
        $ctrl.selectedOffering = $ctrl.offering;
        $ctrl.vehicleCoveragesExist = doVehicleCoveragesExistOnOffering();
        function doVehicleCoveragesExistOnOffering() {
            var result = false;
            $ctrl.selectedOffering.vehicleCoverages.forEach(function (vehicle) {
                vehicle.coverages.forEach(function (coverage) {
                    if (coverage.selected) {
                        result = true;
                    }
                });
            });
            return result;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/pa/directives/PaOfferingSelection/mobileQuoteView/mobileCoveragesSummary/mobileCoveragesSummary.js
// module id = 2171
// module chunks = 0